module.exports = __webpack_public_path__ + "img/no-winner.908b3e4f.png";